import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = [
    "agencyContainer",
    "agencyField",
    "receiveAdminEmailsContainer",
    "receiveAdminEmailsField",
    "roleSelect",
    "flagReasonContainer",
    "flagSelect",
    "flagReasonField"
  ]

  static values = { roles: Object }

  connect() {
    if (this.hasRoleSelectTarget) {
      this.roleSelectTarget.dispatchEvent(new Event("change"))
    }

    this.flagSelectTarget.dispatchEvent(new Event("change"))
  }

  toggleFields({ target: { value } }) {
    this.#toggleReceiveAdminEmails(value)
    this.#toggleAgency(value)
  }

  toggleFlagReason({ target: { value } }) {
    const isRedFlagged = ["red_flagged_non_payment", "red_flagged_accidental_bidding"].includes(value)
    this.flagReasonContainerTarget.classList.toggle(this.hiddenClass, !isRedFlagged)
    this.flagReasonFieldTarget.focus()
    this.flagReasonFieldTarget.setSelectionRange(-1, -1)
  }

  #toggleReceiveAdminEmails(value) {
    const isAdminSelected = this.rolesValue[value]
    const action = isAdminSelected ? "remove" : "add"
    this.receiveAdminEmailsContainerTarget.classList[action](this.hiddenClass)

    if (!isAdminSelected) {
      this.receiveAdminEmailsFieldTarget.checked = false
    }
  }

  #toggleAgency(value) {
    if (!this.hasAgencyContainerTarget) {
      return
    }

    const agencyRoleTypes = ["agency", "regional_admin", "marketplace_agent"]

    const role = this.rolesValue[value]
    const showAgencySelector = agencyRoleTypes.includes(role?.role_type) || role?.key === "billing_restricted_agency_admin"

    const action = showAgencySelector ? "remove" : "add"
    this.agencyContainerTarget.classList[action](this.hiddenClass)
    this.agencyFieldTarget.required = showAgencySelector

    if (!showAgencySelector) {
      this.agencyFieldTarget.value = ""
    }
  }
}
